import { authenticationService } from '../Services';

export function authHeader() {
    const currentUser = authenticationService.currentUserValue;

    if (currentUser && currentUser.token) {
        return { mode: 'no-cors', Authorization: `Bearer ${currentUser.token}` };
    }

    return {};
}
